import moment from "moment";
import { object, string, array, number, InferType, boolean } from "yup";
import { TLangType } from "../LangType";
import { TContentType, TWritingType } from "./order";

export const boostMetricSchema = object({
    position: number().notRequired(),
    isFavorite: boolean().nullable(),
    topPosition: number().notRequired(),
    initialVolume: number().notRequired(),
    urlMaxTraffic: number().notRequired(),
    rdInitialTraffic: number().notRequired(),
    silos: number().notRequired().default(0),
    nl: number().notRequired().default(0),
    volume: number().notRequired(),
    monitorankID: string().nullable(),
    popcashId: number().nullable(),
    popPrice: number().nullable(),
    kd: number().notRequired(),
    views: number().notRequired(),
    costs: number().notRequired(),
    cpm: number().nullable(),
    maxCost: number().nullable(),
    urlTraffic: number().notRequired(),
    rdTraffic: number().notRequired(),
    propelleradsId: number().notRequired(),
    lastBoostMetricsRequested: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    firstBoostDate: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    lastBoostDate: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    poppedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),

    updatedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
});

export const BoostMetricGridSchema = object({
    id: number().required(),
    isFavorite: boolean().notRequired(),
    keywords: array().of(string()),
    indexed: number(),
    monitorankID: string().nullable(),
    silos: number().notRequired().default(0),
    nl: number().notRequired().default(0),
    contentType: string<TContentType>().required("error.order.contentType.required"),
    url: string(),
    writingType: string<TWritingType>().required("error.order.writingType.required"),
    lang: string<TLangType>(),
    popcashId: number().nullable(),
    popPrice: number().nullable(),
    cpm: number().nullable(),
    maxCost: number().nullable(),
    domain: string(),
    position: number().notRequired(),
    topPosition: number().notRequired(),
    initialVolume: number().notRequired(),
    urlMaxTraffic: number().notRequired(),
    rdInitialTraffic: number().notRequired(),
    volume: number().notRequired(),
    kd: number().notRequired(),
    views: number().notRequired(),
    costs: number().notRequired(),
    urlTraffic: number().notRequired(),
    rdTraffic: number().notRequired(),
    propelleradsId: number().notRequired(),
    lastBoostMetricsRequested: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    publishedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    firstBoostDate: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    lastBoostDate: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
    poppedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),

    updatedAt: string()
        .optional()
        .transform((v1) => {
            if (!v1) return;
            return moment(v1).tz("Europe/Paris").format("YYYY-MM-DD");
        }),
});

export type boostMetricGrid = InferType<typeof BoostMetricGridSchema>;
